import { fetchBlogTypeStylings } from '@/utils';

const BlogPostType = ({ post }: { post: any }) => {
  const typeStyling = fetchBlogTypeStylings(post.type);

  return (
    <div
      className={`flex p-3 justify-center items-center gap-2.5 rounded ${typeStyling.bg} w-fit border-[0.5px] ${typeStyling.border}`}
    >
      <span className={`${typeStyling.text} text-center text-[12px] font-medium leading-3`}>
        {post.type}
      </span>
    </div>
  );
};

export default BlogPostType;
